import { render, staticRenderFns } from "./PersonNotes.vue?vue&type=template&id=9cb9ae8c&"
import script from "./PersonNotes.vue?vue&type=script&lang=ts&"
export * from "./PersonNotes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports